/* tslint:disable */
/* eslint-disable */
/**
 * Minimal API - JWT Authentication with Swagger demo
 * Implementing JWT Authentication in Minimal API
 *
 * The version of the OpenAPI document: v1
 * Contact: mbobka@mbobka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserModel
 */
export interface UserModel {
    /**
     *
     * @type {string}
     * @memberof UserModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    lastName?: string | null;
    /**
     *
     * @type {string}
     * @memberof UserModel
     */
    occupation?: string | null;
    /**
     * Подтверждён ли e-mail пользователя.
     * @type {boolean}
     * @memberof UserModel
     */
    emailConfirmed?: boolean;
}

/**
 * Check if a given object implements the UserModel interface.
 */
export function instanceOfUserModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserModelFromJSON(json: any): UserModel {
    return UserModelFromJSONTyped(json, false);
}

export function UserModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'occupation': !exists(json, 'occupation') ? undefined : json['occupation'],
        'emailConfirmed': !exists(json, 'emailConfirmed') ? undefined : json['emailConfirmed'],
    };
}

export function UserModelToJSON(value?: UserModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'username': value.username,
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'occupation': value.occupation,
        'emailConfirmed': value.emailConfirmed,
    };
}

